import React from 'react';
import { useTasks } from '../hooks/useTasks';

export const TasksContext = React.createContext<ReturnType<typeof useTasks> | undefined>(undefined);

export const useTasksContext = (): ReturnType<typeof useTasks> => {
  const context = React.useContext(TasksContext);
  if (!context) {
    throw new Error('useTasksContext must be used within a TasksProvider');
  }
  return context;
};
